import { c as _c } from "react/compiler-runtime";
import { postHostedUserConsent } from '@onefootprint/fetch-hosted';
import { IcoInfo16, LogoIcoVerified } from '@onefootprint/icons';
import type { VerifiedPrefillContext } from '@onefootprint/request-types';
import { Tooltip } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { Trans, useTranslation } from 'react-i18next';
export const useMarkConsentMutation = (identifyToken, context) => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pin-verification.verifiedPrefill"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("identify", t0);
  let t1;
  if ($[1] !== context || $[2] !== identifyToken || $[3] !== t) {
    t1 = {
      mutationFn: async () => {
        if (!context?.isEnabled) {
          return;
        }
        const disclaimerText = context.collectsSsn ? t(_temp) : t(_temp2);
        await postHostedUserConsent({
          body: {
            content: disclaimerText,
            kind: "verified_prefill"
          },
          headers: {
            "X-Fp-Authorization": identifyToken
          }
        });
      }
    };
    $[1] = context;
    $[2] = identifyToken;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return useMutation(t1);
};
type VerifiedPrefillDisclaimerProps = {
  collectsSsn: boolean;
};
export const VerifiedPrefillDisclaimer = t0 => {
  const $0 = _c(5);
  const {
    collectsSsn
  } = t0;
  let t1;
  if ($0[0] !== collectsSsn) {
    t1 = $ => collectsSsn ? $["pin-verification"].verifiedPrefill.disclaimer : $["pin-verification"].verifiedPrefill.disclaimerWithoutSsn;
    $0[0] = collectsSsn;
    $0[1] = t1;
  } else {
    t1 = $0[1];
  }
  let t2;
  if ($0[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      linkButton: <a href="https://verified.inc" target="_blank" rel="noopener noreferrer" className="text-accent" />
    };
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  let t3;
  if ($0[3] !== t1) {
    t3 = <Trans ns="identify" i18nKey={t1} components={t2} />;
    $0[3] = t1;
    $0[4] = t3;
  } else {
    t3 = $0[4];
  }
  return t3;
};
export const PoweredByVerified = () => {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pin-verification.verifiedPrefill"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("identify", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp4);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="text-label-2 text-primary">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LogoIcoVerified />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <Trans ns="identify" i18nKey={_temp3} components={{
      oneClickSignup: t2,
      icon: t3
    }} />;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp5);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IcoInfo16 color="tertiary" className="ml-1" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <Tooltip content={t5} side="bottom">{t6}</Tooltip>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <p className="text-body-2 text-tertiary flex items-center gap-1 justify-center">{t4}{t7}</p>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp($) {
  return $.disclaimer;
}
function _temp2($_0) {
  return $_0.disclaimerWithoutSsn;
}
function _temp3($) {
  return $["pin-verification"].verifiedPrefill.poweredBy;
}
function _temp4($_0) {
  return $_0.oneClickSignup;
}
function _temp5($_1) {
  return $_1.oneClickSignupTooltip;
}